// ============================================
// SVG ICON COMPONENTS
// ============================================

/**
 * IconUser: User/people icon
 * Used in metrics section to represent total employees
 */
export const IconUser = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        d="M3.333 4.667a2.667 2.667 0 1 0 5.334 0 2.667 2.667 0 0 0-5.334 0Z"
        stroke="#2A987A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14v-1.333c0-.708.281-1.386.781-1.886A2.667 2.667 0 0 1 4.667 10h2.666c.708 0 1.386.281 1.887.781.5.5.78 1.178.78 1.886V14"
        stroke="#2A987A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 2.087a3 3 0 0 1 1.445.947c.374.467.571 1.043.571 1.635a3 3 0 0 1-.571 1.635 3 3 0 0 1-1.445.948"
        stroke="#2A987A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14v-1.333a2.667 2.667 0 0 0-2-2.567"
        stroke="#2A987A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * IconCircle: Circle/progress icon
 * Used in metrics section to represent diagnostics sent and competencies
 */
export const IconCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#b)">
      {[
        "M5.706 2.46c-.728.302-1.39.744-1.947 1.3",
        "M2.46 5.707A6 6 0 0 0 2 8",
        "M2.46 10.293c.302.728.744 1.39 1.3 1.947",
        "M5.707 13.54A6 6 0 0 0 8 14",
        "M10.293 13.54c.728-.302 1.39-.744 1.947-1.3",
        "M13.54 10.293A6 6 0 0 0 14 8",
        "M13.54 5.707c-.302-.728-.744-1.39-1.3-1.947",
        "M10.293 2.46A6 6 0 0 0 8 2",
      ].map((d, i) => (
        <path
          key={i}
          d={d}
          stroke="#2A987A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * IconCheck: Checkmark icon
 * Used in metrics section to represent completed rubrics
 */
export const IconCheck = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#c)">
      <path
        d="m3.333 8 3.334 3.333L13.333 4.667"
        stroke="#2A987A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="c">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * IconEdit: Pencil icon for edit action
 */
export const IconEdit = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

/**
 * IconTrash: Trash icon for delete action
 */
export const IconTrash = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <line x1="10" y1="11" x2="10" y2="17" />
    <line x1="14" y1="11" x2="14" y2="17" />
  </svg>
);

/**
 * IconArticle: Article/document icon for recommendation drawer
 */
export const IconArticle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clipPath="url(#clip0_594_291)">
      <path d="M16 6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V18C20 18.5304 19.7893 19.0391 19.4142 19.4142C19.0391 19.7893 18.5304 20 18 20M18 20C17.4696 20 16.9609 19.7893 16.5858 19.4142C16.2107 19.0391 16 18.5304 16 18V5C16 4.73478 15.8946 4.48043 15.7071 4.29289C15.5196 4.10536 15.2652 4 15 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H18Z" stroke="#51CC77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 8H12" stroke="#51CC77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 12H12" stroke="#51CC77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 16H12" stroke="#51CC77" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_594_291">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
